/* Yatay fotoğraf şeridi — başlığın yanındaki oklar bir kart kadar kaydırır.
   Kaydırmanın kendisi tarayıcının kaydırma kutusunda; oklar yalnızca
   scrollBy çağırıyor, böylece dokunmatikte momentum bozulmuyor. */
(function () {
  'use strict';

  class KsStrip extends HTMLElement {
    connectedCallback() {
      const section = this.closest('.ks-strip');
      if (!section) return;

      const step = (direction) => {
        const first = this.firstElementChild;
        const gap = parseFloat(getComputedStyle(this).columnGap || '16') || 16;
        const width = first ? first.offsetWidth + gap : 300;
        this.scrollBy({ left: direction * width, behavior: 'smooth' });
      };

      const prev = section.querySelector('[data-strip-prev]');
      const next = section.querySelector('[data-strip-next]');
      if (prev) prev.addEventListener('click', () => step(-1));
      if (next) next.addEventListener('click', () => step(1));
    }
  }

  if (!customElements.get('ks-strip')) customElements.define('ks-strip', KsStrip);
})();
